/* eslint-disable default-case */
import React from 'react';
import strings from 'utils/strings';
import './styles.scss';
import moment from 'moment';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import {updateObject} from '../../../utils/reducerUtils';
import addMomentsToTestResults from '../../../utils/addMomentsToTestResults';
import getBatchedTestResults from '../../../utils/getBatchedTestResults';

import getGroupedTestAdminClassResults from '../../../api/getGroupedTestAdminClassResults';
import getAllClasses from '../../../api/getAllClasses';
import deleteClasses from '../../../api/deleteClasses';
import addClassesToGroup from '../../../api/addClassesToGroup';
import roundWithDecimals from 'utils/roundWithDecimals';
import updateLogEvent from 'api/updateLogEvent';
import InformationPane from '../../../components/InformationPane';
import getTestsAverageScore from 'api/getTestsAverageScore';
import getTestResultPath from 'utils/getTestResultPath';

import {
	COMPLETED,
	DISTRIBUTED,
	NOT_STARTED,
	STARTED,
	TEST_TYPE_NAMES,
} from 'constants/index';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faPlus,
	faTrash,
	faExchangeAlt,
	faChartColumn,
} from '@fortawesome/free-solid-svg-icons';

import RenderSubTableModal from './renderSubTableModal';

const processTestResults = (testResults, recentKey) => {
	const testResultsWithStatus = testResults.map((testResult) => {
		let status;
		if (testResult.completedAt) {
			status = COMPLETED;
		} else if (testResult.usedAt) {
			status = STARTED;
		} else if (testResult.distributedAt) {
			status = DISTRIBUTED;
		} else {
			status = NOT_STARTED;
		}

		return updateObject(testResult, {
			status,
		});
	});

	const testResultsWithMoments = addMomentsToTestResults(
		testResultsWithStatus
	);

	const batchedTestResults = getBatchedTestResults(testResultsWithMoments);
	return batchedTestResults;
};

const allMyClasses = strings.allMyClasses;
let sortOrder = true;
class MyClasses extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMainChecked: false,
			singleChecks: false,
			selectedClass: '',
			isGroupPanelActive: false,
			allMyClasses: '',
			individualCandidates: [],
			selectedClasses: [],
			customTableClass: 'lit-myClass_grid',
			allClassData: this.props.classData,
			selectedClassData: this.props.classData,
			audioData: [],
			groupClassData: [],
			timeOut: false,
			silence: true,
			renderPaneAlert: false,
			selectedGroup: null,
			groupTestResults: [],
			isAddingClassToGroup: false,
			hasRelevantClasses: false,
			selectedGroupOption: 'Alle mine klasser',
			isGroupDropDownOpen: false,
			selectedChooseGroupOption: '',
			isChooseGroupDropDownOpen: false,
			selectedType: null,
			showSubTableModal: false,
		};
		this.chooseGroupDropdownRef = React.createRef();
		this.groupDropdownRef = React.createRef();
		this.handleClick = this.handleClick.bind(this);
	}
	componentDidMount() {
		document.addEventListener('click', this.handleOutsideClick);

		let hasRelevantClasses = false;
		const {allClassData} = this.state;

		hasRelevantClasses = allClassData.some((config) => {
			if (!config.groupId || config.ownsClass) {
				return true;
			}
		});

		this.setState({allMyClasses: allMyClasses, hasRelevantClasses});
		this.fetchAndRefreshAdminClasses();
	}
	componentWillReceiveProps() {
		let hasRelevantClasses = false;
		const {classData} = this.props;
		if (!this.state.isGroupPanelActive) {
			hasRelevantClasses = classData.some((config) => {
				if (!config.groupId || config.ownsClass) {
					return true;
				}
			});
			this.setState({
				allMyClasses: this.state.allMyClasses,
				hasRelevantClasses,
				selectedClassData: classData,
			});
		} else {
			const newClassData = [];
			for (let i = 0; i < classData.length; i++) {
				if (
					classData[i].groupId &&
					this.state.selectedGroup[0].id === classData[i].groupId
				) {
					newClassData.push(classData[i]);
					hasRelevantClasses = true;
				}
			}
			this.setState({
				allMyClasses,
				isGroupPanelActive: true,
				hasRelevantClasses: hasRelevantClasses,
				selectedClassData: newClassData,
				groupClassData: newClassData,
				isAddingClassToGroup: false,
			});
		}
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.handleOutsideClick);
	}
	handleOutsideClick = (event) => {
		if (
			this.chooseGroupDropdownRef.current &&
			!this.chooseGroupDropdownRef.current.contains(event.target)
		) {
			this.setState({isChooseGroupDropDownOpen: false});
		}
		if (
			this.groupDropdownRef.current &&
			!this.groupDropdownRef.current.contains(event.target)
		) {
			this.setState({isGroupDropDownOpen: false});
		}
	};

	deleteSelectedClasses(extractedIds, subsId) {
		deleteClasses(extractedIds, subsId).then(() => {
			getAllClasses().then((classData) => {
				const adminClasses = classData.map((usersClass) => ({
					className: usersClass.className,
					classId: usersClass.classId,
				}));
				this.setState({
					selectedClassData: classData,
					allClassData: classData,
				});
			});
		});
	}

	fetchAndRefreshAdminClasses() {
		getAllClasses().then((classData) => {
			var selectedClassData = classData;
			const uncheckedClassData = [];
			for (let i = 0; i < selectedClassData.length; i++) {
				if (selectedClassData[i].checked) {
					selectedClassData[i].checked = false;
				}
				uncheckedClassData.push(selectedClassData[i]);
			}

			this.setState({
				selectedClassData: uncheckedClassData,
				allClassData: uncheckedClassData,
				isAddingClassToGroup: false,
			});
		});
	}

	getAndSetAdminClasses() {
		getAllClasses().then((classData) => {
			var selectedClassData = classData;
			const uncheckedClassData = [];
			for (let i = 0; i < selectedClassData.length; i++) {
				if (selectedClassData[i].checked) {
					selectedClassData[i].checked = false;
				}

				uncheckedClassData.push(selectedClassData[i]);
			}

			this.setState({
				selectedClassData: uncheckedClassData,
				allClassData: uncheckedClassData,
				paneMessage: strings.candidatesAddedToGroup,
				renderPaneMessage: true,
				isAddingClassToGroup: false,
			});
		});
	}
	addSelectedClassesToGroup(classIds, groupIds) {
		const groupedClasses = {classIds, groupIds};
		if (!classIds || !groupIds) {
			return;
		}

		addClassesToGroup(groupedClasses).then((res) => {
			this.getAndSetAdminClasses();
		});
	}

	handleClick = (id, key) => {
		this.updateViewLog(id, key);
	};

	updateViewLog(id, key) {
		updateLogEvent('view', id, key, 'Results').then(() => {});
	}

	getAndSetTestCandidatesAverageScore(testData, classData) {
		const {currentUser} = this.props;
		const id = currentUser.id;
		return getTestsAverageScore(testData).then((averageZScore) => {
			return new Promise((resolve) => {
				classData.averageZscore = roundWithDecimals(averageZScore, 4);
				this.setState(
					{
						averageZScore,
					},
					resolve
				);
			});
		});
	}

	sortTableBy(identifier) {
		const {selectedClassData} = this.state;
		sortOrder = !sortOrder;
		switch (identifier) {
			case 'name':
				selectedClassData.sort(this.compareByName);
				break;
			case 'candidates':
				selectedClassData.sort(this.compareBytests);
				break;
		}
		this.setState({selectedClassData});
	}

	compareByName(a, b) {
		if (!sortOrder) {
			if (a.className.toLowerCase() < b.className.toLowerCase()) {
				return 1;
			}
			if (a.className.toLowerCase() > b.className.toLowerCase()) {
				return -1;
			}
			return 0;
		}
		if (a.className.toLowerCase() > b.className.toLowerCase()) {
			return 1;
		}
		if (a.className.toLowerCase() < b.className.toLowerCase()) {
			return -1;
		}
		return 0;
	}
	compareBytests(a, b) {
		if (!sortOrder) {
			if (a.strength < b.strength) {
				return 1;
			}
			if (a.strength > b.strength) {
				return -1;
			}
			return 0;
		}
		if (a.strength > b.strength) {
			return 1;
		}
		if (a.strength < b.strength) {
			return -1;
		}
		return 0;
	}
	renderCustomTableHeader() {
		return (
			<div>
				<div className="lit-myClass-header_grid">
					<div className="lit-myClass-header-wrapper">
						<div className="checkbox-wrapper-13">
							<input
								type="checkbox"
								disabled
								className="lit_cb_users"
								id="main_checkbox"
								onChange={(e) => {
									if (e.target.checked) {
										const checkedClassData =
											this.state.selectedClassData.map(
												(data) => {
													data.checked = true;
													return data;
												}
											);

										this.setState({
											isMainChecked: true,
											selectedClassData: checkedClassData,
										});
									} else {
										const checkedClassData =
											this.state.selectedClassData.map(
												(data) => {
													data.checked = false;
													return data;
												}
											);

										this.setState({
											isMainChecked: false,
											selectedClassData: checkedClassData,
										});
									}
								}}
							/>
						</div>

						<div className="myClass_table-title-header-name">
							<span
								className="className-title"
								onClick={() => {
									this.sortTableBy('name');
								}}
							>
								{strings.className}
								<FontAwesomeIcon
									icon={faExchangeAlt}
									rotation={90}
									className="sort-icon"
								/>
							</span>
						</div>
						<div className="myClass_table-title-header myClass_header--count">
							<span
								className="total-candidates"
								onClick={() => {
									this.sortTableBy('candidates');
								}}
							>
								{strings.numberOfCandidates}
								<FontAwesomeIcon
									icon={faExchangeAlt}
									rotation={90}
									className="sort-icon"
								/>
							</span>
						</div>
						<div
							className="myClass_table-title-header myClass_header--done"
							onClick={() => {
								/* this.sortTableBy('tests'); */
							}}
						>
							<span>{strings.testsCompleted}</span>
						</div>
						<div className="myClass_table-title-header myClass_header--z">
							<span>{strings.averageZScore}</span>
						</div>
						<div className="myClass_table-title-header" />
					</div>
				</div>
			</div>
		);
	}
	renderCustomTable(classData) {
		return (
			<div>
				<div
					className="lit-myClass_grid"
					id={classData.className}
					onClick={() => {
						if (!classData.active) {
							classData.active = true;
							this.setState({
								selectedClass: classData.className,
								showSubTableModal: true,
								selectedType: null,
							});
						}
					}}
				>
					{!this.state.isMainChecked && !this.state.singleChecks && (
						<div
							className="checkbox-wrapper-13"
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<input
								type="checkbox"
								key={classData.classId}
								className="lit_cb_users"
								/* defaultChecked={classData.checked ? true : false} */
								disabled={!classData.ownsClass}
								checked={classData.checked}
								id={3}
								onChange={(e) => {
									if (e.target.checked) {
										classData.checked = true;
										/* if(this.state.isGroupPanelActive){}
										else{
											
										} */
										this.setState({
											selectedClassData:
												this.state.selectedClassData,
										});
									} else {
										classData.checked = false;
										this.setState({
											selectedClassData:
												this.state.selectedClassData,
										});
									}
								}}
							/>
						</div>
					)}
					{this.state.isMainChecked && (
						<div
							className="checkbox-wrapper-13"
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<input
								type="checkbox"
								className="lit_cb_users"
								defaultChecked
								disabled={!classData.ownsClass}
								id={4}
								onChange={(e) => {
									if (e.target.checked) {
										classData.checked = true;
										this.setState({
											selectedClassData:
												this.props.classData,
										});
									} else {
										classData.checked = false;
										this.setState({
											selectedClassData:
												this.props.classData,
										});
									}
								}}
							/>
						</div>
					)}
					<div className="myClass_name_table-cell-name">
						<span>{classData.className}</span>
					</div>
					<div className="myClass_name_table-cell myClass_cell--count">
						{classData.strength}
					</div>
					<div className="myClass_name_table-cell myClass_cell--done">
						{this.calculateCompletedTests(
							classData.classInfo,
							this.props.batchedFilteredTestResults
						)}
					</div>
					<div className="myClass_name_table-cell myClass_cell--z">
						<span
							className="lit-average-zs"
							onClick={(event) => {
								event.stopPropagation();
								const someData = this.getFilteredTestUsers(
									classData.classInfo,
									this.props.batchedFilteredTestResults
								);
								const testData = someData.map((data) => {
									return {
										id: data.id,
										type: data.type,
										key: data.key,
									};
								});
								this.getAndSetTestCandidatesAverageScore(
									testData,
									classData
								);
							}}
						>
							{classData.averageZscore}
						</span>
					</div>
					<div className="myClass_name_table-cell-expand-btn">
						<div className="lit-list__text">
							<button className="lit-btn lit-btn--small bg-primary5">
								<span>{strings.seeTests}</span>
							</button>
						</div>
					</div>
				</div>
				{classData.active === true && this.state.showSubTableModal && (
					<RenderSubTableModal
						closeWindow={() => {
							classData.active = false;

							this.setState({
								showSubTableModal: false,
							});
						}}
						selectedClass={this.state.selectedClass}
					>
						{this.renderSubTable(
							this.getFilteredTestUsers(
								classData.classInfo,
								this.props.batchedFilteredTestResults
							),
							classData.classInfo
						)}
					</RenderSubTableModal>
				)}
			</div>
		);
	}
	calculateCompletedTests(classInfo, allTestUsers) {
		const allUsers = classInfo.map((data) => {
			return data.candidateId;
		});

		if (!this.state.isGroupPanelActive) {
			const tempObj = [];
			for (let i = 0; i < allTestUsers.length; i++) {
				const testsResults = allTestUsers[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}
			const count = tempObj.filter(
				(singleInstance) => singleInstance.completedAt
			).length;

			return `${count}/${tempObj.length}`;
		} else if (
			this.state.isGroupPanelActive &&
			this.state.groupTestResults.length
		) {
			const {groupTestResults} = this.state;
			const tempObj = [];

			for (let i = 0; i < groupTestResults.length; i++) {
				const testsResults = groupTestResults[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}
			const count = tempObj.filter(
				(singleInstance) => singleInstance.completedAt
			).length;

			return `${count}/${tempObj.length}`;
		}
	}

	renderSubTable(singleCandidate, classInfoResults) {
		if (!singleCandidate) {
			return (
				<div className="mcx-drawer">
					<p>{strings.classHasNoTestResults}</p>
				</div>
			);
		}
		const mapA = classInfoResults.reduce((acc, item) => {
			acc[item.candidateId] = item.subTestsResults;
			return acc;
		}, {});
		singleCandidate.forEach((item) => {
			const testUserId = item.testUser?.testUserId;
			item.subTestsResults = mapA[testUserId] || [];
		});
		const testType = singleCandidate[0].type || null;

		// ✅ detect available types
		const hasScreening = singleCandidate.some((c) =>
			c.type.includes('screening')
		);
		const hasFollowup = singleCandidate.some((c) =>
			c.type.includes('followup')
		);

		// ✅ determine correct selectedType
		let selectedType = this.state.selectedType;

		// if not set OR invalid → fix it
		if (
			!selectedType ||
			(selectedType === 'screening' && !hasScreening) ||
			(selectedType === 'followup' && !hasFollowup)
		) {
			selectedType = hasScreening ? 'screening' : 'followup';

			// sync state (important)
			if (selectedType !== this.state.selectedType) {
				this.setState({selectedType});
			}
		}
		const SCREENING_TESTS = [1, 2, 3, 4, 5, 6];
		const SCREENING_TESTS_CHILD = [3, 2, 4, 6, 5, 1];

		const FOLLOWUP_TESTS = [0, 3, testType.includes('child') ? 8 : 5, 4];

		let tests;

		if (selectedType === 'screening') {
			tests = testType.includes('child')
				? SCREENING_TESTS_CHILD
				: SCREENING_TESTS;
		} else {
			tests = FOLLOWUP_TESTS;
		}
		// helper: map results by test
		const getTestMap = (results = []) => {
			const map = {};

			results.forEach((r) => {
				const existing = map[r.test];

				if (!existing) {
					map[r.test] = r;
				} else if (
					new Date(r.createdAt) < new Date(existing.createdAt)
				) {
					map[r.test] = r;
				}
			});
			return map;
		};
		const SCREENING_TEST_NAMES = {
			1: strings.worddictationtest,
			2: strings.wordchain,
			3: testType.includes('child')
				? strings.swapsoundtest
				: strings.nonwordtest,
			4: strings.typingspeedtest,
			5: strings.readingtest,
			6: strings.wordcomprehensiontest,
		};

		const FOLLOWUP_TEST_NAMES_AND_TYPES = {
			adultyouth: {
				0: strings.workingmemorytest,
				3: strings.rapidautonamingtest,
				4: strings.oneminute,
				5: strings.spoonerism,
			},
			child: {
				0: strings.workingmemorytest,
				3: strings.rapidautonamingtest,
				4: strings.oneminutetest,
				8: strings.phonemeomissiontest,
			},
		};

		const testNames =
			selectedType === 'screening'
				? SCREENING_TEST_NAMES
				: FOLLOWUP_TEST_NAMES_AND_TYPES[
						testType.includes('child') ? 'child' : 'adultyouth'
					];
		const subTableGridStyle = {
			'--mcx-subtable-grid': `minmax(190px, 1.3fr) minmax(150px, 0.85fr) repeat(${tests.length}, minmax(108px, 1fr)) minmax(120px, 0.65fr)`,
			'--mcx-subtable-min-width': `${Math.max(
				900,
				470 + tests.length * 124
			)}px`,
		};

		return (
			<div className="mcx-drawer">
				{/* ✅ FILTER DROPDOWN */}
				<div className="mcx-filter-bar">
					<label className="mcx-filter-label">{strings.type}</label>

					<div className="mcx-select-wrapper">
						<select
							className="mcx-select"
							value={selectedType || ''}
							onChange={(e) =>
								this.setState({
									selectedType: e.target.value,
								})
							}
						>
							{/* ✅ show only if exists */}
							{hasScreening && (
								<option value="screening">
									{strings.screeningTest}
								</option>
							)}

							{hasFollowup && (
								<option value="followup">
									{strings.followUpTest}
								</option>
							)}
						</select>
					</div>
				</div>
				<div className="mcx-legend">
					<div className="mcx-legend-item">
						<span className="mcx-legend-dot red" />
						{strings.redAverageArea}
					</div>

					<div className="mcx-legend-item">
						<span className="mcx-legend-dot yellow" />
						{strings.yellowAverageArea}
					</div>

					<div className="mcx-legend-item">
						<span className="mcx-legend-dot green" />
						{strings.greenAverageArea}
					</div>
				</div>
				<div className="mcx-tests-wrapper" style={subTableGridStyle}>
					{/* HEADER */}
					<div className="mcx-tests__header">
						<div title={strings.testCandidate}>
							{strings.testCandidate}
						</div>

						<div title={strings.status}>{strings.status}</div>
						{tests.map((t) => (
							<div key={t} title={testNames[t]}>
								{testNames[t]}
							</div>
						))}
						<div className="mcx-actions-header">
							{strings.resultsReport}
						</div>
					</div>

					{/* ROWS */}
					<ul className="mcx-tests">
						{singleCandidate
							.filter((c) =>
								selectedType
									? c.type.includes(selectedType)
									: true
							)
							.map((c) => {
								const {
									id,
									key,
									testUser,
									status,
									type,
									createdAt,
									completedAt,
									usedAt,
									distributedAt,
									testVersion,
									subTestsResults,
								} = c;

								const fmt = (d) => moment(d).format('DD.MM.YY');

								let label = '';
								let date = '';

								if (completedAt) {
									label = strings.completed;
									date = fmt(completedAt);
								} else if (usedAt) {
									label = strings.started;
									date = fmt(usedAt);
								} else if (distributedAt) {
									label = strings.distributed;
									date = fmt(distributedAt);
								} else if (createdAt) {
									label = strings.createdOn;
									date = fmt(createdAt);
								}

								const fullName = testUser
									? `${testUser.firstName} ${testUser.lastName}`
									: '';

								return (
									<li className="mcx-testrow" key={key}>
										<div className="mcx-col mcx-candidate-name">
											{fullName || (
												<b>{strings.notdistributed}</b>
											)}
										</div>
										<div className="mcx-col mcx-status">
											{label && (
												<div className="lit-test__date">
													<div className="lit-test__label">
														{label}
													</div>
													<div className="lit-test__value">
														{date}
													</div>
												</div>
											)}
										</div>

										{(() => {
											const testMap =
												getTestMap(subTestsResults);

											return tests.map((testNum) => {
												const t = testMap[testNum];

												let colorClass =
													'mcx-cell-gray';

												if (t) {
													if (t.zScore < -1)
														colorClass =
															'mcx-cell-red';
													else if (t.zScore <= 1)
														colorClass =
															'mcx-cell-yellow';
													else
														colorClass =
															'mcx-cell-green';
												}

												return (
													<div
														key={testNum}
														className={`mcx-col mcx-cell ${colorClass}`}
													>
														{t
															? t.zScore.toFixed(
																	2
																)
															: '-'}
													</div>
												);
											});
										})()}

										<div className="mcx-col mcx-actions">
											{this.renderButton(
												type,
												id,
												status,
												key,
												testVersion
											)}
										</div>
									</li>
								);
							})}
					</ul>
				</div>
			</div>
		);
	}

	renderButton(type, id, status, key, testVersion) {
		const completed = status === COMPLETED;
		const started = status === STARTED;

		const destination = getTestResultPath(type, id, testVersion);

		if (completed || started) {
			return (
				<div className="table-action">
					<Link
						className="icon-btn"
						to={destination}
						onClick={() => this.handleClick(id, key)}
						target="_blank"
						rel="noopener noreferrer"
					>
						<FontAwesomeIcon icon={faChartColumn} />
					</Link>
				</div>
			);
		}

		return null;
	}
	getTestDateInfo(createdAt, completedAt, usedAt, distributedAt) {
		let testDateInfo;
		if (completedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.completed}
						<br />
						{moment(completedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		} else if (usedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.started}
						<br />
						{moment(usedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		} else if (distributedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.distributed}
						<br />
						{moment(distributedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		} else if (createdAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.createdOn}
						<br />
						{moment(createdAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		}

		return testDateInfo;
	}
	getFilteredTestUsers(classData, allTestUsers) {
		const allUsers = classData.map((data) => {
			return data.candidateId;
		});
		if (!this.state.isGroupPanelActive) {
			const tempObj = [];
			for (let i = 0; i < allTestUsers.length; i++) {
				const testsResults = allTestUsers[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}

			if (tempObj.length) {
				return tempObj;
			}
		} else if (this.state.isGroupPanelActive) {
			const {groupTestResults} = this.state;
			const tempObj = [];
			for (let i = 0; i < groupTestResults.length; i++) {
				const testsResults = groupTestResults[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}

			if (tempObj.length) {
				return tempObj;
			}
		}

		return null;
	}

	async getAndSetTestAdminGroupedClassTestResults(selectedGroup) {
		const selectedgroup = selectedGroup;
		if (selectedGroup !== '') {
			const testResults =
				await getGroupedTestAdminClassResults(selectedgroup);
			const batchedTestResults = await processTestResults(
				testResults.testResults,
				null
			);
			return await new Promise((resolve) => {
				this.setState(
					{
						allCandidates: testResults.testUsers,
						isGroupPanelActive: true,
						groupTestResults: batchedTestResults,
						isClassPanelActive: false,
					},
					resolve
				);
			});
		}
		return null;
	}

	onHandleGroupDropDownOpen = (e) => {
		const newClassData = [];
		if (e.includes('groupTitle')) {
			const newClassData = [];

			const classIds = [];
			let hasRelevantClasses = false;

			let extractedGroup = e.split('groupTitle');
			const groupName = extractedGroup[extractedGroup.length - 1];
			const chosenGroup = this.props.userGroups.filter(
				(group) => group.name === groupName
			);
			this.getAndSetTestAdminGroupedClassTestResults(chosenGroup[0].id);
			for (let i = 0; i < this.state.allClassData.length; i++) {
				if (
					this.state.allClassData[i].groupId &&
					chosenGroup[0].id === this.state.allClassData[i].groupId
				) {
					newClassData.push(this.state.allClassData[i]);
					hasRelevantClasses = true;
				}
			}
			this.setState({
				allMyClasses: e,
				isGroupPanelActive: true,
				hasRelevantClasses: hasRelevantClasses,
				selectedClassData: newClassData,
				groupClassData: newClassData,
				selectedGroup: chosenGroup,
			});
		} else {
			let hasRelevantClasses = false;
			const checkedClassData = this.props.testUsers.map((data) => {
				data.checked = false;
				return data;
			});
			for (let i = 0; i < this.state.allClassData.length; i++) {
				if (
					!this.state.allClassData[i].groupId ||
					this.state.allClassData[i].ownsClass
				) {
					newClassData.push(this.state.allClassData[i]);
					hasRelevantClasses = true;
				}
			}

			this.setState({
				isGroupPanelActive: false,
				hasRelevantClasses: hasRelevantClasses,
				selectedClassData: newClassData,
				allMyClasses: allMyClasses,
			});
		}
	};
	toggleGroupsDropdown = () => {
		this.setState((prevState) => ({
			isGroupDropDownOpen: !prevState.isGroupDropDownOpen,
		}));
	};
	toggleChooseGroupDropdown = () => {
		this.setState((prevState) => ({
			isChooseGroupDropDownOpen: !prevState.isChooseGroupDropDownOpen,
		}));
	};
	render() {
		const {
			selectedClassData,
			isGroupDropDownOpen,
			selectedGroupOption,
			selectedChooseGroupOption,
			isChooseGroupDropDownOpen,
		} = this.state;

		return (
			<div className="mcx-page">
				<div className="lit-tests-view__header">
					{/* <div className="audio" id="audio"></div> */}
					<div className="lit-new-test__wrapper">
						<div className="lit-input-tab-grid">
							{
								<>
									{Boolean(selectedClassData.length) && (
										<button
											className="lit-mytests-header-mytest-btn-ternary"
											onClick={() => {
												const extractSelectedClasses =
													selectedClassData.filter(
														(data) => data.checked
													);
												let controlDeletion = false;
												if (
													!extractSelectedClasses.length
												) {
													this.setState({
														renderPaneAlert: true,
													});
												} else {
													const extractedIds =
														extractSelectedClasses.map(
															(classIds) => {
																if (
																	classIds.ownsClass
																)
																	return classIds.classId;

																controlDeletion = true;
															}
														);
													const subsId =
														extractSelectedClasses[0]
															.subscription;
													if (controlDeletion) {
														window.alert(
															strings.alert_cannotDeleteClassNotOwned
														);
													} else if (
														window.confirm(
															strings.formatString(
																strings.confirmationdeleteclass,
																`${
																	extractedIds.length >
																	1
																		? strings.multipleclasses
																		: strings.theclass
																}`
															)
														)
													) {
														this.deleteSelectedClasses(
															extractedIds,
															subsId
														);
													}
												}
												this.setState({
													allMyClasses:
														strings.allMyClasses,
												});
											}}
										>
											<FontAwesomeIcon
												className="lit-icon-btns"
												icon={faTrash}
											/>
											<p className="lit-btns-txt-negative">
												{strings.deleteclass}
											</p>
										</button>
									)}
									{/*scrollers starting div*/}
									{this.state.renderPaneMessage && (
										<InformationPane
											paneMessage={this.state.paneMessage}
											onApproval={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											onCloseWindow={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											onDisproval={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											category={'information'}
										/>
									)}

									{Boolean(
										this.state.allClassData.length
									) && (
										<div className="lit-View_tests">
											<div
												className="select-container"
												ref={this.groupDropdownRef}
											>
												<div
													className="select-display"
													onClick={
														this
															.toggleGroupsDropdown
													}
												>
													{selectedGroupOption ||
														strings.allMyClasses}
													<span className="dropdown-arrow">
														▼
													</span>
												</div>
												{isGroupDropDownOpen && (
													<div className="dropdown-list-withScroller">
														<div
															className="dropdown-item"
															onClick={() => {
																this.setState({
																	selectedGroupOption:
																		strings.allMyClasses,
																	isGroupDropDownOpen: false,
																});
																this.onHandleGroupDropDownOpen(
																	'Alle mine klasser'
																);
															}}
														>
															{strings.allMyClasses}
														</div>
														{Boolean(
															this.props
																.userGroups
																.length
														) && (
															<div
																className="dropdown-item disabled"
																onClick={() => {
																	this.setState(
																		{
																			isGroupDropDownOpen: false,
																		}
																	);
																}}
															>
																{
																	strings.classesInGroups
																}
															</div>
														)}
														{Boolean(
															this.props
																.userGroups
																.length
														) &&
															this.props.userGroups.map(
																(
																	groups,
																	index
																) => (
																	<div
																		className="dropdown-item"
																		key={
																			index
																		}
																		onClick={() => {
																			this.setState(
																				{
																					selectedGroupOption:
																						groups.name,
																					isGroupDropDownOpen: false,
																				}
																			);
																			this.onHandleGroupDropDownOpen(
																				`groupTitle${groups.name}`
																			);
																		}}
																	>
																		{
																			groups.name
																		}
																	</div>
																)
															)}
													</div>
												)}
											</div>
										</div>
									)}

									{this.state.isAddingClassToGroup && (
										<div
											className="select-container"
											ref={this.chooseGroupDropdownRef}
										>
											<div
												className="select-display"
												onClick={
													this
														.toggleChooseGroupDropdown
												}
											>
												{selectedChooseGroupOption ||
													this.props.userGroups[0]
														.name}
												<span className="dropdown-arrow">
													▼
												</span>
											</div>
											{isChooseGroupDropDownOpen && (
												<div className="dropdown-list">
													{this.props.userGroups.map(
														(group, index) => (
															<div
																className="dropdown-item"
																onClick={() => {
																	const chosenGroup =
																		this.props.userGroups.filter(
																			(
																				groupp
																			) =>
																				groupp.name ===
																				group.name
																		);
																	const chosengroup =
																		chosenGroup[0];

																	this.setState(
																		{
																			groupId:
																				chosengroup.id,
																			selectedChooseGroupOption:
																				chosengroup.name,
																			isChooseGroupDropDownOpen: false,
																		}
																	);
																}}
																key={index}
															>
																{group.name}
															</div>
														)
													)}
												</div>
											)}
										</div>
									)}

									{Boolean(selectedClassData.length) && (
										<button
											className="lit-mytests-header-mytest-btn-secondary"
											onClick={() => {
												const extractSelectedClasses =
													selectedClassData.filter(
														(data) => data.checked
													);
												if (
													!extractSelectedClasses.length
												) {
													this.setState({
														renderPaneAlert: true,
													});
												} else if (
													!this.state
														.isAddingClassToGroup
												) {
													const classIds =
														extractSelectedClasses.map(
															(classIds) => {
																return classIds.classId;
															}
														);

													const groupId =
														this.props.userGroups[0]
															.id;
													this.setState({
														isAddingClassToGroup: true,
														selectedClasses:
															classIds,
														groupId,
													});
												} else {
													const {
														selectedClasses,
														groupId,
													} = this.state;
													this.addSelectedClassesToGroup(
														selectedClasses,
														groupId
													);
												}
											}}
										>
											<FontAwesomeIcon
												className="lit-icon-btns"
												icon={faPlus}
											/>
											<p className="lit-btns-txt">
												{!this.state
													.isAddingClassToGroup
													? strings.addtogroup
													: strings.add}
											</p>
										</button>
									)}
								</>
							}
						</div>
					</div>
				</div>

				<div className="lit-tests-view__contant">
					<div className="lit-btn_grid">
						{(!this.state.selectedClassData.length ||
							!this.state.hasRelevantClasses) && (
							<p>{strings.message_noclasses}</p>
						)}

						{this.state.hasRelevantClasses &&
							Boolean(this.state.selectedClassData.length) && (
								<div className="lit-main-candidates-contianer">
									<div className="lit_myClass_table-wrapper">
										{this.renderCustomTableHeader()}

										{selectedClassData.map(
											(data, index) => {
												if (
													this.state
														.selectedGroupOption ===
														'Alle mine klasser' &&
													data.ownsClass
												) {
													return (
														<div key={index}>
															{this.renderCustomTable(
																data
															)}
														</div>
													);
												} else if (
													this.state
														.selectedGroupOption !==
														'Alle mine klasser' &&
													data.groupId
												) {
													return (
														<div key={index}>
															{this.renderCustomTable(
																data
															)}
														</div>
													);
												}
												return <div key={index} />;
											}
										)}
									</div>
								</div>
							)}
					</div>

					{this.state.renderPaneAlert && (
						<InformationPane
							paneMessage={strings.chooseclass}
							onApproval={() => {
								this.setState({
									renderPaneAlert: false,
								});
							}}
							onCloseWindow={() => {
								this.setState({
									renderPaneAlert: false,
								});
							}}
							onDisproval={() => {
								this.setState({
									renderPaneAlert: false,
								});
							}}
							category={'information'}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default MyClasses;
